module.exports = __webpack_public_path__ + "assets/img/logo_01.93760a04.png";